// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';
import { of } from 'rxjs';

export type UploadImageResp = {
  +type: string;
  +id: string;
  +resourceGroup: string;
  +resourceId: string;
  +url: string;
};

export const endpoints = Object.freeze({
  GET_PURCHASE: `${environment.apiUrl}/purchase/:id`,
  GET_SALE: `${environment.apiUrl}/sale/:id`,
  GET_MESSAGES: `${environment.apiUrl}/messaging/order/:id`,
  POST_MESSAGE: `${environment.apiUrl}/messaging/new/order/:id`,
  UPLOAD_IMAGE: `${environment.apiUrl}/image/upload`,
});

export const getPurchaseApi = getCreator(fetch, endpoints.GET_PURCHASE);
export const getSaleApi = getCreator(fetch, endpoints.GET_SALE);
export const postMessageApi = postCreator(fetch, endpoints.POST_MESSAGE);
export const getMessagesApi = getCreator(fetch, endpoints.GET_MESSAGES);
export const uploadImageApi = postCreator(fetch, endpoints.UPLOAD_IMAGE);



// WEBPACK FOOTER //
// ./src/modules/order/api.js